// import React, { useEffect, useState } from "react";
// import { Applogo, profileLogo } from "../../../Routes/ImagePath";
// import { DatePicker } from "antd";
// import axios from "axios";
// import { Api_Url } from "../../../config/config";
// import { ErrorToast, SuccessToast } from "../../ToastComponent";

// export const OTCClearanceModalPopup = ({ OTCClearanceFetchData }) => {
//   const initialTableData = [
//     {
//       module: "Projects",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Tasks",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Chat",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Estimates",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Invoices",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Timing Sheets",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//   ];

//   const [tableData, setTableData] = useState(initialTableData);
//   // const [radioValue, setRadioValue] = useState(null);
//   const [allbranch, setAllBranch] = useState([]);

//   const [isCollected, setIsCollected] = useState(false);
//   const [isNotCollected, setIsNotCollected] = useState(false);
//   const [isPartialCollected, setIsPartialCollected] = useState(false);

//   const [LocalFormData, setLocalFormData] = useState({
//     BranchId: "",
//     Name: "",
//     Mobile: "",
//     ApplicationNo: "",
//     LoanNumber: "",
//     OTCDocumentsCollected: "",
//     ExpectedDate: new Date(),
//     Latitude: "",
//     Longitude: "",
//   });


//   useEffect(() => {
//     const AllBranchName = async () => {
//       try {
//         const response = await axios.get(
//           `${Api_Url}api/v1/Branch?PageNumber=1&PageSize=1000`,{
//             headers: {
//               Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//             }
//           }
//         );
//         setAllBranch(response.data.data);
//       } catch (error) {
//         console.error(error);
//       }
//     };
//     AllBranchName();
//   }, []);

//   useEffect(() => {
//     if ("geolocation" in navigator) {
//       navigator.geolocation.getCurrentPosition((position) => {
//         const { latitude, longitude } = position.coords;
//         setLocalFormData((prevData) => ({
//           ...prevData,
//           Latitude: latitude,
//           Longitude: longitude,
//         }));
//       });
//     } else {
//       console.log("Geolocation is not supported by this browser.");
//     }
//   }, []);


//   const handleDateChange = (date) => {
//     setLocalFormData((prevData) => ({ ...prevData, ExpectedDate: date }));
//   };

//   const HandleSubmit = async () => {
//     const formatDateToUTC = (dateString) => {
//       const date = new Date(dateString);
//       const year = date.getUTCFullYear();
//       const month = String(date.getUTCMonth() + 1).padStart(2, "0");
//       const day = String(date.getUTCDate()).padStart(2, "0");
//       const hours = String(date.getUTCHours()).padStart(2, "0");
//       const minutes = String(date.getUTCMinutes()).padStart(2, "0");
//       const seconds = String(date.getUTCSeconds()).padStart(2, "0");
//       const milliseconds = String(date.getUTCMilliseconds()).padStart(3, "0");
//       return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}.${milliseconds}`;
//     };

//     if (LocalFormData.Mobile.length !== 10) {
//       ErrorToast("Mobile Number must be exactly 10 digits.");
//       return;
//     };

//     let collectedStatus = 0;
//     if (isCollected) {
//       collectedStatus = 1;
//     } else if (isPartialCollected) {
//       collectedStatus = 2;
//     } else if (isNotCollected) {
//       collectedStatus = 3;
//     }

//     const formData = new FormData();

//     formData.append("BranchId", LocalFormData.BranchId);
//     formData.append("Name", LocalFormData.Name);
//     formData.append("Mobile", LocalFormData.Mobile);
//     formData.append("ApplicationNo", LocalFormData.ApplicationNo);
//     formData.append("LoanNumber", LocalFormData.LoanNumber);
//     formData.append("OTCDocumentsCollected", collectedStatus);
//     // formData.append("ExpectedDate", formatDateToUTC(LocalFormData.ExpectedDate));
//     formData.append("Latitude", LocalFormData.Latitude);
//     formData.append("Longitude", LocalFormData.Longitude);
//     if (isNotCollected || isPartialCollected) {
//       formData.append(
//         "ExpectedDate",
//         formatDateToUTC(LocalFormData.ExpectedDate)
//       );
//     }

//     // Object.entries(LocalFormData).forEach(([key, value]) => {
//     //   formData.append(key, value);
//     // });

//     try {
//       const response = await axios.post(
//         `${Api_Url}api/v1/OTCClearance`,
//         formData,
//         {
//           headers: {
//             Authorization: `Bearer ${
//               JSON.parse(sessionStorage.getItem("user")).accessToken
//             }`,
//             "Content-Type": "multipart/form-data",
//           },
//         }
//       );
//       console.log(response);
//       OTCClearanceFetchData();
//       resetForm()
//       SuccessToast("OTC Clearance Submitted Successfully")
//     } catch (error) {
//       return error;
//     }
//   };

//   const resetForm = () => {
//     setLocalFormData({
//       BranchId: "",
//       Name: "",
//       Mobile: "",
//       ApplicationNo: "",
//       LoanNumber: "",
//       OTCDocumentsCollected: "",
//       ExpectedDate: new Date(),
//     });
//     setIsCollected(false);
//     setIsNotCollected(false);
//     setIsPartialCollected(false);
//   };

//   const handleCheckboxChange = (module, column) => {
//     const updatedTableData = [...tableData];
//     const row = updatedTableData.find((item) => item.module === module);
//     row[column] = !row[column];
//     setTableData(updatedTableData);
//   };

//   const validateMobileNumber = (number) => {
//     const regex = /^[0-9]{0,10}$/;
//     return regex.test(number);
//   };

//   const handleMobileChange = (e) => {
//     const value = e.target.value;
//     if (validateMobileNumber(value)) {
//       setLocalFormData({
//         ...LocalFormData,
//         Mobile: value,
//       });
//     }}

//   return (
//     <>
//       <div
//         id="add_client"
//         className="modal custom-modal fade"
//         role="dialog"
//         data-bs-backdrop="static"
//         data-bs-keyboard="false"
//       >
//         <div
//           className="modal-dialog modal-dialog-centered modal-lg"
//           role="document"
//         >
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">OTC Clearnce</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               >
//                 <span aria-hidden="true">×</span>
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="profile-image text-center mt-4 mb-4">
//                 <img
//                   src={AllFormsUpperphoto}
//                   alt="mohit"
//                   className="img-fluid rounded-circle"
//                   style={{ width: "100px", height: "100px" }}
//                 />
//               </div>

//               <form>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Branch <span className="text-danger">*</span>
//                       </label>
//                       <select
//                         className="form-control"
//                         value={LocalFormData.BranchId}
//                         onChange={(e) =>
//                           setLocalFormData({
//                             ...LocalFormData,
//                             BranchId: e.target.value,
//                           })
//                         }
//                       >
//                         <option value="">Select Branch</option>
//                         {allbranch &&
//                           allbranch.length > 0 &&
//                           allbranch.map((res) => (
//                             <option key={res.id} value={res.id}>
//                               {res.name}
//                             </option>
//                           ))}
//                       </select>
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Customer Name <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={LocalFormData.Name}
//                         onChange={(e) =>
//                           setLocalFormData({
//                             ...LocalFormData,
//                             Name: e.target.value,
//                           })
//                         }
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Mobile <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control"
//                         type="number"
//                         value={LocalFormData.Mobile}
//                         onChange={handleMobileChange}
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Application NO. <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={LocalFormData.ApplicationNo}
//                         onChange={(e) =>
//                           setLocalFormData({
//                             ...LocalFormData,
//                             ApplicationNo: e.target.value,
//                           })
//                         }
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Loan Number <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control"
//                         type="text"
//                         value={LocalFormData.LoanNumber}
//                         onChange={(e) =>
//                           setLocalFormData({
//                             ...LocalFormData,
//                             LoanNumber: e.target.value,
//                           })
//                         }
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-12">
//                     <label className="col-form-label">
//                       New Customer <span className="text-danger">*</span>
//                     </label>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault"
//                         id="flexRadioDefault1"
//                         value="true"
//                         checked={LocalFormData.IsPurposeMet === true}
//                         onChange={(e) =>
//                           setLocalFormData({
//                             ...LocalFormData,
//                             IsPurposeMet: e.target.value === "true",
//                           })
//                         }
//                       />
//                       <label
//                         className="form-check-label"
//                         htmlFor="flexRadioDefault1"
//                       >
//                         Yes
//                       </label>
//                     </div>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault"
//                         id="flexRadioDefault2"
//                         value="false"
//                         checked={LocalFormData.IsPurposeMet === false}
//                         onChange={(e) =>
//                           setLocalFormData({
//                             ...LocalFormData,
//                             IsPurposeMet: e.target.value === "true",
//                           })
//                         }
//                       />
//                       <label
//                         className="form-check-label"
//                         htmlFor="flexRadioDefault2"
//                       >
//                         No
//                       </label>
//                     </div>
//                   </div>
//                   <div className="col-md-12">
//                     <label className="col-form-label">
//                       Document Collected <span className="text-danger">*</span>
//                     </label>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="emiStatus"
//                         id="collected"
//                         checked={isCollected}
//                         onChange={(e) => {
//                           setIsCollected(e.target.checked);
//                           setIsNotCollected(false);
//                           setIsPartialCollected(false);
//                         }}
//                       />
//                       <label className="form-check-label" htmlFor="collected">
//                         Collected
//                       </label>
//                     </div>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="emiStatus"
//                         id="partialCollected"
//                         checked={isPartialCollected}
//                         onChange={(e) => {
//                           setIsPartialCollected(e.target.checked);
//                           setIsCollected(false);
//                           setIsNotCollected(false);
//                         }}
//                       />
//                       <label
//                         className="form-check-label"
//                         htmlFor="partialCollected"
//                       >
//                         Partial Collected
//                       </label>
//                     </div>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="emiStatus"
//                         id="notCollected"
//                         checked={isNotCollected}
//                         onChange={(e) => {
//                           setIsNotCollected(e.target.checked);
//                           setIsCollected(false);
//                           setIsPartialCollected(false);
//                         }}
//                       />
//                       <label
//                         className="form-check-label"
//                         htmlFor="notCollected"
//                       >
//                         Not Collected
//                       </label>
//                     </div>
//                   </div>

//                   {(isPartialCollected || isNotCollected) && (
//                     <div className="col-md-6">
//                       <div className="input-block mb-3">
//                         <label className="col-form-label">
//                           Visit Date <span className="text-danger">*</span>
//                         </label>
//                         <DatePicker
//                           selected={LocalFormData.ExpectedDate}
//                           onChange={handleDateChange}
//                           className="form-control"
//                         />
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </form>

//               <div className="submit-section">
//               <button
//                     className="btn btn-primary submit-btn"
//                     data-bs-dismiss="modal"
//                     aria-label="Close"
//                     type="button"
//                     onClick={HandleSubmit}
//                   >
//                     Submit
//                   </button>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };




// MOdal

import React, { useEffect, useState } from "react";
import { DatePicker, Modal } from "antd";
import axios from "axios";
import { ErrorToast, SuccessToast } from "../../ToastComponent";
import { Api_Url } from "../../../config/config";
import { AllFormsUpperphoto } from "../../../Routes/ImagePath";

export const OTCClearanceModalPopup = ({ OTCClearanceFetchData, onClose }) => {
  const [allbranch, setAllBranch] = useState([]);
  const [loading, setLoading] = useState(false);

  const [LocalFormData, setLocalFormData] = useState({
    BranchId: "",
    Name: "",
    Mobile: "",
    ApplicationNo: "",
    LoanNumber: "",
    OTCDocumentsCollected: "", // Will be '1', '2', or '3'
    ExpectedDate: null, // Use null instead of new Date()
    Latitude: "",
    Longitude: "",
    NewCustomer: "", // 'Yes' or 'No'
  });

  // Fetch branches on component mount
  useEffect(() => {
    const AllBranchName = async () => {
      try {
        const response = await axios.get(
          `${Api_Url}api/v1/Branch?PageNumber=1&PageSize=1000`,
          {
            headers: {
              Authorization: `Bearer ${
                JSON.parse(sessionStorage.getItem("user")).accessToken
              }`,
            },
          }
        );
        setAllBranch(response.data.data);
      } catch (error) {
        console.error(error);
      }
    };
    AllBranchName();
  }, []);

  // Get user's geolocation
  useEffect(() => {
    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        const { latitude, longitude } = position.coords;
        setLocalFormData((prevData) => ({
          ...prevData,
          Latitude: latitude.toString(),
          Longitude: longitude.toString(),
        }));
      });
    } else {
      console.log("Geolocation is not supported by this browser.");
    }
  }, []);

  // Handle form inputs
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setLocalFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  // Handle mobile number input
  const handleMobileChange = (e) => {
    const value = e.target.value;
    if (/^\d{0,10}$/.test(value)) {
      setLocalFormData((prevData) => ({
        ...prevData,
        Mobile: value,
      }));
    }
  };

  // Handle date change
  const handleDateChange = (date) => {
    setLocalFormData((prevData) => ({ ...prevData, ExpectedDate: date }));
  };

  // Handle radio button change for OTCDocumentsCollected
  const handleOTCDocumentsCollectedChange = (e) => {
    setLocalFormData((prevData) => ({
      ...prevData,
      OTCDocumentsCollected: e.target.value,
    }));
  };

  // Handle radio button change for NewCustomer
  const handleNewCustomerChange = (e) => {
    setLocalFormData((prevData) => ({
      ...prevData,
      NewCustomer: e.target.value,
    }));
  };

  // Validate form before submission
  const validateForm = () => {
    const {
      BranchId,
      Name,
      Mobile,
      ApplicationNo,
      LoanNumber,
      OTCDocumentsCollected,
      ExpectedDate,
    } = LocalFormData;

    if (!BranchId || !Name || !Mobile || Mobile.length !== 10 || !ApplicationNo || !LoanNumber) {
      ErrorToast("Please fill in all required fields correctly.Mobile Number must be 10 digit.");
      return false;
    }

    if (!OTCDocumentsCollected) {
      ErrorToast("Please select the document collection status.");
      return false;
    }

    if ((OTCDocumentsCollected === '2' || OTCDocumentsCollected === '3') && !ExpectedDate) {
      ErrorToast("Please select an expected date.");
      return false;
    }

    return true;
  };

  // Handle form submission
  const HandleSubmit = async () => {
    setLoading(true);

    if (!validateForm()) {
      setLoading(false);
      return;
    }

    const formatDateToUTC = (date) => {
      if (!date) return null;
      return date.toISOString();
    };

    const formData = new FormData();
    formData.append("BranchId", LocalFormData.BranchId);
    formData.append("Name", LocalFormData.Name);
    formData.append("Mobile", LocalFormData.Mobile);
    formData.append("ApplicationNo", LocalFormData.ApplicationNo);
    formData.append("LoanNumber", LocalFormData.LoanNumber);
    formData.append("OTCDocumentsCollected", LocalFormData.OTCDocumentsCollected);
    formData.append("Latitude", LocalFormData.Latitude);
    formData.append("Longitude", LocalFormData.Longitude);
    formData.append("NewCustomer", LocalFormData.NewCustomer === 'Yes');

    if (LocalFormData.OTCDocumentsCollected === '2' || LocalFormData.OTCDocumentsCollected === '3') {
      formData.append("ExpectedDate", formatDateToUTC(LocalFormData.ExpectedDate));
    }

    try {
      const response = await axios.post(
        `${Api_Url}api/v1/OTCClearance`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${
              JSON.parse(sessionStorage.getItem("user")).accessToken
            }`,
            "Content-Type": "multipart/form-data",
          },
        }
      );
      OTCClearanceFetchData();
      resetForm();
      SuccessToast("OTC Clearance Submitted Successfully");
      onClose();
    } catch (error) {
      ErrorToast("An error occurred while submitting.");
    } finally {
      setLoading(false);
    }
  };

  // Reset form to initial state
  const resetForm = () => {
    setLocalFormData({
      BranchId: "",
      Name: "",
      Mobile: "",
      ApplicationNo: "",
      LoanNumber: "",
      OTCDocumentsCollected: "",
      ExpectedDate: null,
      // NewCustomer: "",
    });
  };

  return (
    <Modal
      title={<h4>OTC Clearance</h4>}
      open={true}
      onOk={onClose}
      onCancel={onClose}
      footer={[
        <div
          className="d-flex justify-content-between align-items-center"
          key="footer"
        >
          <button className="btn btn-danger submit-btn" onClick={onClose}>
            Cancel
          </button>
          <button
            className="btn btn-primary submit-btn"
            onClick={HandleSubmit}
            disabled={loading}
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </div>,
      ]}
      width={600}
      maskClosable={false}
      closeIcon={<span style={{ color: "red" }}>X</span>}
    >
      <div className="modal-body mt-5">
        <div className="profile-image text-center mt-4 mb-4">
          <img
            src={AllFormsUpperphoto}
            alt="Profile"
            className="img-fluid rounded-circle"
            style={{ width: "100px", height: "100px" }}
          />
        </div>
        <form>
          <div className="row">
            {/* Branch */}
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Branch <span className="text-danger">*</span>
                </label>
                <select
                  className="form-control"
                  name="BranchId"
                  value={LocalFormData.BranchId}
                  onChange={handleInputChange}
                >
                  <option value="">Select Branch</option>
                  {allbranch &&
                    allbranch.length > 0 &&
                    allbranch.map((res) => (
                      <option key={res.id} value={res.id}>
                        {res.name}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            {/* Customer Name */}
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Customer Name <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="Name"
                  value={LocalFormData.Name}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            {/* Mobile */}
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Mobile <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="Mobile"
                  value={LocalFormData.Mobile}
                  onChange={handleMobileChange}
                />
              </div>
            </div>
            {/* Application No */}
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Application No. <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="ApplicationNo"
                  value={LocalFormData.ApplicationNo}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            {/* Loan Number */}
            <div className="col-md-6">
              <div className="input-block mb-3">
                <label className="col-form-label">
                  Loan Number <span className="text-danger">*</span>
                </label>
                <input
                  className="form-control"
                  type="text"
                  name="LoanNumber"
                  value={LocalFormData.LoanNumber}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            {/* New Customer */}
            {/* <div className="col-md-12">
              <label className="col-form-label">
                New Customer <span className="text-danger">*</span>
              </label>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="NewCustomer"
                  value="Yes"
                  checked={LocalFormData.NewCustomer === "Yes"}
                  onChange={handleNewCustomerChange}
                />
                <label className="form-check-label" htmlFor="newCustomerYes">
                  Yes
                </label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="NewCustomer"
                  value="No"
                  checked={LocalFormData.NewCustomer === "No"}
                  onChange={handleNewCustomerChange}
                />
                <label className="form-check-label" htmlFor="newCustomerNo">
                  No
                </label>
              </div>
            </div> */}
            {/* Document Collected */}
            <div className="col-md-12 mt-3">
              <label className="col-form-label">
                Document Collected <span className="text-danger">*</span>
              </label>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="OTCDocumentsCollected"
                  value="1"
                  checked={LocalFormData.OTCDocumentsCollected === "1"}
                  onChange={handleOTCDocumentsCollectedChange}
                />
                <label className="form-check-label">
                  Collected
                </label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="OTCDocumentsCollected"
                  value="2"
                  checked={LocalFormData.OTCDocumentsCollected === "2"}
                  onChange={handleOTCDocumentsCollectedChange}
                />
                <label className="form-check-label">
                  Partial Collected
                </label>
              </div>
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="radio"
                  name="OTCDocumentsCollected"
                  value="3"
                  checked={LocalFormData.OTCDocumentsCollected === "3"}
                  onChange={handleOTCDocumentsCollectedChange}
                />
                <label className="form-check-label">
                  Not Collected
                </label>
              </div>
            </div>
            {/* Expected Date (conditionally rendered) */}
            {(LocalFormData.OTCDocumentsCollected === "2" || LocalFormData.OTCDocumentsCollected === "3") && (
              <div className="col-md-6 mt-3">
                <div className="input-block mb-3">
                  <label className="col-form-label">
                    Expected Date <span className="text-danger">*</span>
                  </label>
                  <DatePicker
                    className="form-control"
                    value={LocalFormData.ExpectedDate}
                    onChange={handleDateChange}
                  />
                </div>
              </div>
            )}
          </div>
        </form>
      </div>
    </Modal>
  );
};




// import React, { useEffect, useState } from "react";
// import { Applogo, profileLogo } from "../../../Routes/ImagePath";
// import { DatePicker } from "antd";
// import { Radio } from "react-feather";
// import { useNavigate } from "react-router-dom";
// import { Api_Url } from "../../../config/config";
// import axios from "axios";

// export const OTCClearanceModalPopup = () => {
//   const initialTableData = [
//     {
//       module: "Projects",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Tasks",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Chat",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Estimates",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Invoices",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//     {
//       module: "Timing Sheets",
//       read: true,
//       write: true,
//       create: true,
//       delete: true,
//       import: true,
//       export: true,
//     },
//   ];

//   //   let yourDate = new Date()
//   // // yourDate.toISOString().split('T')[0]

//   // const today=(yourDate.toISOString().split('T')[0])

//   const [tableData, setTableData] = useState(initialTableData)

//   // const [userId,setUserId] = useState('')

//   // useEffect(() => {
//   //  const id= JSON.parse(sessionStorage.getItem('user'))
//   // setUserId(id)
//   // }, [])

//   const AllFileLoginData = async () => {
//     try {
//       const id = JSON.parse(sessionStorage.getItem('user'))?.id
//       console.log("id", id)
//       const response = await axios.get(`${Api_Url}api/v1/FileLogin/${id}`, {
//         headers: {
//           Authorization: `Bearer ${JSON.parse(sessionStorage.getItem('user')).accessToken}`,
//         }
//       })
//       console.log("response", response)
//     } catch (error) {
//       return error
//     }
//   }

//   useEffect(() => {
//     AllFileLoginData()
//   }, [])

//   const [radioValue, setRadioValue] = useState(false);

//   // const [location, setLocation] = useState(null);

//   const [LocalFormData, setLocalFormData] = useState({

//     BranchId: "",
//     Name: "",
//     Mobile: "",
//     ApplicationNo: "",
//     LoanNumber:"",
//     OTCDocumentsCollected:"",
//     // IsFileLoggedIn: radioValue,
//     ExpectedDate: new Date(),
//     Latitude: "",
//     Longitude: "",
//   });

//   const handleRadioChange = (e) => {
//     setRadioValue(e.target.value === 'true');

//   };

//   const handleDateChange = (date) => {
//     setLocalFormData({ ...LocalFormData, VisitDate: date });
//   };

//   useEffect(() => {
//     if ("geolocation" in navigator) {
//       navigator.geolocation.getCurrentPosition(function (position) {

//         const { latitude, longitude } = position.coords;
//         setLocalFormData({ ...LocalFormData, Latitude: latitude, Longitude: longitude });
//       });
//     } else {
//       console.log("Geolocation is not supported by this browser.");
//     }
//   }, [])

//   // console.log("location",location?.latitude)

//   const HandleSubmit = () => {

//     const formData = new FormData();
//     formData.append("BranchId", LocalFormData.BranchId);
//     formData.append("Name", LocalFormData.Name);
//     formData.append("Mobile", LocalFormData.Mobile);
//     formData.append("ApplicationNo", LocalFormData.ApplicationNo);
//     formData.append("LoanNumber", LocalFormData.LoanNumber);
//     formData.append("OTCDocumentsCollected", LocalFormData.OTCDocumentsCollected);
//     formData.append("ExpectedDate", formatDateToUTC(LocalFormData.ExpectedDate));
//     formData.append("IsFileLoggedIn", LocalFormData.IsFileLoggedIn);
//     formData.append("Latitude", LocalFormData.Latitude);
//     formData.append("Longitude", LocalFormData.Longitude);

//     console.log(LocalFormData)
//   }

//   const handleCheckboxChange = (module, column) => {
//     // Create a copy of the tableData
//     const updatedTableData = [...tableData];

//     // Find the row with the specified module
//     const row = updatedTableData.find((item) => item.module === module);

//     // Toggle the checkbox value
//     row[column] = !row[column];

//     // Set the updated data
//     setTableData(updatedTableData);
//   };

//   const [allbranch,setAllBranch] = useState('')

//   const AllBranchName=async () =>{
//     try {
//       const response = await axios.get(`${Api_Url}api/v1/Branch?PageNumber=1&PageSize=1000`)
//       // console.log("response",response.data.data)
//       setAllBranch(response.data.data)
//     } catch (error) {
//       console.log("object",error)
//     }
//   }
//   console.log(allbranch)

//   useEffect(()=>{
//     AllBranchName()
//   },[])

//   return (
//     <>
//       <div id="add_client" className="modal custom-modal fade" role="dialog">
//         <div
//           className="modal-dialog modal-dialog-centered modal-lg"
//           role="document"
//         >
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">File Login</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               >
//                 <span aria-hidden="true">×</span>
//               </button>
//             </div>
//             <div className="modal-body">
//               <div className="profile-image text-center mt-4 mb-4">
//                 <img
//                   // src={{Applogo} ? {Applogo} : {profileLogo}}
//                   src='https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTYP-KKtRJXm9qK7k2_PA1utxbxWdpzGIdulQ&s'
//                   alt='mohit'
//                   className="img-fluid rounded-circle"
//                   style={{ width: '100px', height: '100px' }}
//                 />
//               </div>

//               <form>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Branch <span className="text-danger">*</span>
//                       </label>
//                       <select
//                         className="form-control"
//                         value={LocalFormData.BranchId}
//                         onChange={(e) => setLocalFormData({ ...LocalFormData, BranchId: e.target.value })}
//                       >
//                         <option value="">Select Branch</option>
//                         {allbranch && allbranch.length>0 && allbranch.map((res)=>(
//                         <option value={res.id}>{res.name}</option>
//                        ))}
//                         {/* Add more branches as needed */}
//                       </select>
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Customer Name <span className="text-danger">*</span></label>
//                       <input className="form-control" type="text" value={LocalFormData.Name} onChange={(e) => setLocalFormData({ ...LocalFormData, Name: e.target.value })} />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Mobile <span className="text-danger">*</span>
//                       </label>
//                       <input className="form-control" type="number" value={LocalFormData.Mobile} onChange={(e) => setLocalFormData({ ...LocalFormData, Mobile: e.target.value })} />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Application NO. <span className="text-danger">*</span></label>
//                       <input className="form-control" type="text" value={LocalFormData.Name} onChange={(e) => setLocalFormData({ ...LocalFormData, Name: e.target.value })} />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">LoanNumber <span className="text-danger">*</span></label>
//                       <input className="form-control" type="text" value={LocalFormData.Name} onChange={(e) => setLocalFormData({ ...LocalFormData, Name: e.target.value })} />
//                     </div>
//                   </div>
//                   <div className="col-md-12">
//           <label className="col-form-label">
//             New Customer <span className="text-danger">*</span>
//           </label>
//           <div className="form-check">
//             <input
//               className="form-check-input"
//               type="radio"
//               name="newCustomer"
//               id="newCustomerYes"
//               // value="true"
//               // checked={LocalFormData.NewCustomer === true}
//               // onChange={handleNewCustomerChange}
//             />
//             <label className="form-check-label" htmlFor="newCustomerYes">
//               Yes
//             </label>
//           </div>
//           <div className="form-check">
//             <input
//               className="form-check-input"
//               type="radio"
//               name="newCustomer"
//               id="newCustomerNo"
//               // value="false"
//               // checked={LocalFormData.NewCustomer === false}
//               // onChange={handleNewCustomerChange}
//             />
//             <label className="form-check-label" htmlFor="newCustomerNo">
//               No
//             </label>
//           </div>
//         </div>

//                   <div className="col-md-12">
//                     <label className="col-form-label">
//                       Document Collected <span className="text-danger">*</span>
//                     </label>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault"
//                         id="flexRadioDefault1"
//                         value="true"
//                         checked={radioValue === true}
//                         onChange={handleRadioChange}
//                       />
//                       <label className="form-check-label" htmlFor="flexRadioDefault1">
//                         Collected
//                       </label>
//                     </div>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault"
//                         id="flexRadioDefault2"
//                         value=""
//                         checked={radioValue === false}
//                         onChange={handleRadioChange}
//                       />
//                       <label className="form-check-label" htmlFor="flexRadioDefault2">
//                         Partial Collected
//                       </label>
//                     </div>
//                     <div className="form-check">
//                       <input
//                         className="form-check-input"
//                         type="radio"
//                         name="flexRadioDefault"
//                         id="flexRadioDefault2"
//                         value=""
//                         checked={radioValue === false}
//                         onChange={handleRadioChange}
//                       />
//                       <label className="form-check-label" htmlFor="flexRadioDefault2">
//                         Not Collected
//                       </label>
//                     </div>
//                   </div>

//                   {/* Conditional rendering based on radio selection */}
//                   {radioValue === true ? (
//                     <div className="col-md-6">
//                       <div className="input-block mb-3">
//                         <label className="col-form-label">
//                           Refference Number <span className="text-danger">*</span>
//                         </label>
//                         <input
//                           placeholder="Enter your reference number"
//                           className="form-control"
//                           type="text"
//                           value={LocalFormData.ApplicationNo}
//                           onChange={(e) => setLocalFormData({ ...LocalFormData, ApplicationNo: e.target.value })}
//                         />
//                       </div>
//                     </div>
//                   ) : (
//                     <div className="col-md-6">
//                       <div className="input-block mb-3">
//                         <label className="col-form-label">
//                           Visit Date <span className="text-danger">*</span>
//                         </label>
//                         <DatePicker
//                           selected={LocalFormData.VisitDate}
//                           onChange={handleDateChange}
//                           className="form-control"
//                         />
//                       </div>
//                     </div>
//                   )}
//                 </div>
//                 <div className="submit-section">
//                   <button
//                     className="btn btn-primary submit-btn"
//                     data-bs-dismiss="modal"
//                     aria-label="Close"
//                     type="button"
//                     onClick={HandleSubmit}
//                   >
//                     Submit
//                   </button>
//                 </div>
//               </form>

//             </div>
//           </div>
//         </div>
//       </div>

//       <div id="edit_client" className="modal custom-modal fade" role="dialog">
//         <div
//           className="modal-dialog modal-dialog-centered modal-lg"
//           role="document"
//         >
//           <div className="modal-content">
//             <div className="modal-header">
//               <h5 className="modal-title">Edit Client</h5>
//               <button
//                 type="button"
//                 className="btn-close"
//                 data-bs-dismiss="modal"
//                 aria-label="Close"
//               >
//                 <span aria-hidden="true">×</span>
//               </button>
//             </div>
//             <div className="modal-body">
//               <form>
//                 <div className="row">
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         First Name <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control"
//                         defaultValue="Barry"
//                         type="text"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Last Name</label>
//                       <input
//                         className="form-control"
//                         defaultValue="Cuda"
//                         type="text"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Username <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control"
//                         defaultValue="barrycuda"
//                         type="text"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Email <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control floating"
//                         defaultValue="barrycuda@example.com"
//                         type="email"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Password</label>
//                       <input
//                         className="form-control"
//                         defaultValue="barrycuda"
//                         type="password"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Confirm Password</label>
//                       <input
//                         className="form-control"
//                         defaultValue="barrycuda"
//                         type="password"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">
//                         Client ID <span className="text-danger">*</span>
//                       </label>
//                       <input
//                         className="form-control floating"
//                         defaultValue="CLT-0001"
//                         type="text"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Phone </label>
//                       <input
//                         className="form-control"
//                         defaultValue={9876543210}
//                         type="text"
//                       />
//                     </div>
//                   </div>
//                   <div className="col-md-6">
//                     <div className="input-block mb-3">
//                       <label className="col-form-label">Company Name</label>
//                       <input
//                         className="form-control"
//                         type="text"
//                         defaultValue="Global Technologies"
//                       />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="table-responsive m-t-15">
//                   <table className="table table-striped custom-table">
//                     <thead>
//                       <tr>
//                         <th>Module Permission</th>
//                         <th className="text-center">Read</th>
//                         <th className="text-center">Write</th>
//                         <th className="text-center">Create</th>
//                         <th className="text-center">Delete</th>
//                         <th className="text-center">Import</th>
//                         <th className="text-center">Export</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {tableData.map((row, index) => (
//                         <tr key={index}>
//                           <td>{row.module}</td>
//                           {[
//                             "read",
//                             "write",
//                             "create",
//                             "delete",
//                             "import",
//                             "export",
//                           ].map((column) => (
//                             <td key={column} className="text-center">
//                               <label className="custom_check">
//                                 <input
//                                   type="checkbox"
//                                   checked={row[column]}
//                                   onChange={() =>
//                                     handleCheckboxChange(row.module, column)
//                                   }
//                                 />
//                                 <span className="checkmark"></span>
//                               </label>
//                             </td>
//                           ))}
//                         </tr>
//                       ))}
//                     </tbody>
//                   </table>
//                 </div>
//                 <div className="submit-section">
//                   <button
//                     className="btn btn-primary submit-btn"
//                     data-bs-dismiss="modal"
//                     aria-label="Close"
//                     type="reset"
//                   >
//                     Save
//                   </button>
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   );
// };
